import React, { useContext } from "react";
import { KBContext } from "../../Context";
import { isFeatureEnabled } from "../../utils";
import { FTR_KB_NEW_LOGIN } from "../../Constants";
import NewLoginPage from "./NewLoginPage";
import OldLoginPage from "./OldLoginPage";

export default function LoginPage() {
    const { availableFeatures } = useContext(KBContext);
    const isOldLoginForced = availableFeatures?.[FTR_KB_NEW_LOGIN] === false;

    if (isOldLoginForced) {
        return <OldLoginPage />;
    }
    return <NewLoginPage />;
}
